import { useEffect, useState } from 'react';
import { subscribeFantasyDataSync } from '../firebase/playerService';

export default function useFantasyDataSyncing() {
  const [state, setState] = useState({ syncing: false, progress: 0, source: 'local' });

  useEffect(() => subscribeFantasyDataSync(setState), []);

  return state;
}
